module.exports = __webpack_public_path__ + "static/media/signage-indoor-img49.0d68413f.jpg";